import * as o from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/WarningDiamond.es.js";
const n = o.forwardRef((a, r) => /* @__PURE__ */ o.createElement(i, { ref: r, ...a, weights: m }));
n.displayName = "WarningDiamondIcon";
const c = n;
export {
  c as WarningDiamond,
  n as WarningDiamondIcon
};
